import React from "react";
import { useSpring } from "react-spring";
import { HamburgerButton, NavLinksContainer, NavLink } from "../header-styles";
import { SidebarContainer, HamburgerContainer, SidebarContentContainer } from "./sidebar-styles";
import circleMenu from "@iconify/icons-system-uicons/circle-menu";
import { IconLink, Separator } from "../..";
import { Overheader } from "../Overheader";

export const Sidebar = ({ forwardRef, show, setShow }) => {
  const { right } = useSpring({
    from: { right: "-100%" },
    right: show ? "0" : "-100%",
  });

  const closeSidebar = () => setShow(false);

  return (
    <SidebarContainer style={{ right: right }} ref={forwardRef}>
      <Overheader />
      <Separator />
      <SidebarContentContainer>
        <HamburgerContainer>
          <HamburgerButton onClick={closeSidebar}>
            <IconLink url={false} icon={circleMenu} color="#fff" size="32px" noPadding />
          </HamburgerButton>
        </HamburgerContainer>
        <NavLinksContainer>
          <NavLink to="/" onClick={closeSidebar}>
            HOME
          </NavLink>
          <NavLink to="/about" onClick={closeSidebar}>
            ABOUT
          </NavLink>
          {/* <NavLink to="/equipment-gallery">EQUIPMENT/GALLERY</NavLink> */}
          <NavLink to="/contact" onClick={closeSidebar}>
            CONTACT
          </NavLink>
        </NavLinksContainer>
      </SidebarContentContainer>
    </SidebarContainer>
  );
};
